import { Tooltip, Badge } from '@chakra-ui/react';
import { IColumn } from '../types';
import { formatDateTimeSafe } from '../../../../../utilities/dateHelpers';
import { EventInfoStatus, ISummaryCalendlyEvent } from 'api-paths-cas';
import { defaultHeaderRenderer } from '../headers';
import { CellEventsHandler } from '../formatters';
import { CellProps } from '../../types';
import { getInterviewInfoStatusString, getInterviewInfoStatusColor } from '../../../../../utilities/formatting';
import { TableDate, BadgeWrap } from '../styles';

const InterviewFormatter = (cellProps: CellProps) => {
  const calendlyInterviews = cellProps.row.calendlyInterviews ?? [];
  const infoStatus = cellProps.row.calendlyInterviewsInfoStatus || EventInfoStatus.NONE;
  let interviewDates = '';

  // First try to get dates from root-level fields
  if (
    cellProps.row.calendlyInterviewStartDate &&
    cellProps.row.calendlyInterviewsInfoStatus === EventInfoStatus.BOOKED
  ) {
    interviewDates = `${formatDateTimeSafe(
      cellProps.row.calendlyInterviewStartDate,
      'DD MMM YYYY HH:mm',
    )}-${formatDateTimeSafe(cellProps.row.calendlyInterviewEndDate, 'HH:mm')}`;
  }
  // If root-level dates are null/undefined, try to get from calendlyInterviews array
  else if (calendlyInterviews.length > 0) {
    const bookedInterview = calendlyInterviews.find(
      (event: ISummaryCalendlyEvent) => event.infoStatus === EventInfoStatus.BOOKED,
    );

    if (bookedInterview && bookedInterview.startDate && bookedInterview.endDate) {
      interviewDates = `${formatDateTimeSafe(bookedInterview.startDate, 'DD MMM YYYY HH:mm')}-${formatDateTimeSafe(
        bookedInterview.endDate,
        'HH:mm',
      )}`;
    }
  }

  const fullText = calendlyInterviews
    .map((event: ISummaryCalendlyEvent) => {
      const name = event.name || '';
      const infoStatus = event.infoStatus || EventInfoStatus.NONE;
      return `${name} - ${getInterviewInfoStatusString(infoStatus)}`;
    })
    .map((str: string, i: number) => <div key={i}>{str}</div>);

  const { colorScheme, variant } = getInterviewInfoStatusColor(infoStatus as EventInfoStatus);

  const TextNode = (
    <BadgeWrap>
      <Badge colorScheme={colorScheme} variant={variant}>
        {getInterviewInfoStatusString(infoStatus as EventInfoStatus)}
      </Badge>

      <TableDate>{interviewDates}</TableDate>
    </BadgeWrap>
  );

  if (calendlyInterviews.length > 0) {
    return (
      <CellEventsHandler cellProps={cellProps}>
        <Tooltip hasArrow placement="top" label={fullText}>
          {TextNode}
        </Tooltip>
      </CellEventsHandler>
    );
  }
  return <CellEventsHandler cellProps={cellProps}>{TextNode}</CellEventsHandler>;
};

export const InterviewColumn = (): IColumn => ({
  item: {
    key: 'scheduledInterviews',
    name: 'Interview bookings',
    headerRenderer: defaultHeaderRenderer,
    sortable: true,
    width: 'minmax(136px, 1.25fr)',
    formatter: InterviewFormatter,
  },
  visible: ({ isInterviewVisible }) => isInterviewVisible!,
});
